import React from 'react';
import { FiEdit2, FiTrash2, FiCheck } from 'react-icons/fi';
import DocumentManager from './DocumentManager';
import './TaskCard.css';

function TaskCard({ task, onEdit, onDelete, onStatusChange }) {
  const priorityEmoji = {
    1: '🔴',
    2: '🟡',
    3: '🟢'
  };

  const statusColor = {
    'A faire': '#ff9800',
    'En cours': '#2196f3',
    'Terminé': '#4caf50',
    'Devis': '#8b5cf6'
  };

  return (
    <div className="task-card">
      <div className="task-header">
        <h4>{task.title}</h4>
        <span className="priority">{priorityEmoji[task.priority] || '🟡'}</span>
      </div>

      {task.description && <p className="task-desc">{task.description}</p>}

      <div className="task-meta">
        <span className="phase">{task.phase_name}</span>
        <span className="status" style={{ backgroundColor: statusColor[task.status] }}>
          {task.status}
        </span>
      </div>

      {task.cost > 0 && <div className="cost">💰 {task.cost.toFixed(2)}€</div>}

      {task.contractor && <div className="contractor">👤 {task.contractor}</div>}

      <div className="task-dates">
        {task.estimated_start_date && (
          <small>📅 Début: {new Date(task.estimated_start_date).toLocaleDateString('fr-FR')}</small>
        )}
        {task.estimated_end_date && (
          <small>📅 Fin: {new Date(task.estimated_end_date).toLocaleDateString('fr-FR')}</small>
        )}
      </div>

      {task.progress !== undefined && (
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${task.progress}%` }}></div>
          <span className="progress-text">{task.progress}%</span>
        </div>
      )}

      <div className="task-actions">
        <button className="icon-btn" onClick={() => onEdit(task)} title="Modifier">
          <FiEdit2 />
        </button>
        <button className="icon-btn success" onClick={() => onStatusChange(task)} title="Marquer terminée">
          <FiCheck />
        </button>
        <button className="icon-btn danger" onClick={() => onDelete(task.id)} title="Supprimer">
          <FiTrash2 />
        </button>
      </div>
      <DocumentManager taskId={task.id} />
    </div>
  );
}

export default TaskCard;
